import { userMixin } from '@beautybox/core/mixins/store/storeUser';

// UI
const AppImageUserAvatar = () =>
    import(
        /* webpackChunkName: "ImageUserAvatar" */ '@beautybox/ui-kit/components/image/ImageUserAvatar'
    );

//Forms
const AppInput = () => import('@beautybox/ui-kit/components/forms/inputs/Input');
const AppInputPhone = () => import('@beautybox/ui-kit/components/forms/inputs/InputPhone');
const AppInputPassword = () => import('@beautybox/ui-kit/components/forms/inputs/InputPassword');
const AppInputSearch = () => import('@beautybox/ui-kit/components/forms/inputs/InputSearch');
const AppSelect = () => import('@beautybox/ui-kit/components/forms/selects/Select');
const AppSelectGender = () => import('@beautybox/ui-kit/components/forms/selects/SelectGender');
const AppAutoComplete = () => import('@beautybox/ui-kit/components/forms/selects/AutoComplete');
const AppSelectBirthday = () => import('@beautybox/ui-kit/components/forms/selects/SelectBirthday');
const AppSwitch = () => import('@beautybox/ui-kit/components/forms/selection-controls/Switch');
const AppTextarea = () => import('@beautybox/ui-kit/components/forms/textareas');
const AppCheckbox = () => import('@beautybox/ui-kit/components/forms/selection-controls/Checkbox');
const AppRadioGenders = () =>
    import('@beautybox/ui-kit/components/forms/selection-controls/RadioGenders');
const AppRating = () => import('@beautybox/ui-kit/components/forms/selection-controls/Rating');
const AppDatePicker = () => import('@beautybox/ui-kit/components/pickers/DatePicker');

//Modals
const AppModalNotEqual = () =>
    import('@beautybox/ui-kit/components/modals/layouts/MMobileFullScreen');
const AppModalLayoutDefault = () =>
    import(
        /* webpackChunkName: "ModalLayoutDefault" */ '@beautybox/ui-kit/components/modals/layouts/ModalLayoutDefault'
    );

//Buttons
const AppBtnClose = () =>
    import(/* webpackChunkName: "BtnClose" */ '@beautybox/ui-kit/components/buttons/BtnClose');

const AppBtnCopy = () =>
    import(/* webpackChunkName: "BtnCopy" */ '@beautybox/ui-kit/components/buttons/AppBtnCopy');

//Helpers
const AppSvg = () =>
    import(/* webpackChunkName: "icon-svg" */ '@beautybox/ui-kit/components/icons/BSvg.vue');
const AppBlockEmpty = () =>
    import(/* webpackChunkName: "BlockEmpty" */ '@beautybox/ui-kit/components/blocks/BlockEmpty');
const AppBlockLoader = () =>
    import(/* webpackChunkName: "BlockLoader" */ '@beautybox/ui-kit/components/blocks/BlockLoader');
const AppBlockLayoutBoxSkeleton = () =>
    import(
        /* webpackChunkName: "BlockLayoutBoxSkeleton" */ '@beautybox/ui-kit/components/blocks/layouts/BlockLayoutBoxSkeleton'
    );
const AppSkeletonBoilerplate = () =>
    import(
        /* webpackChunkName: "SkeletonBoilerplate" */ '@beautybox/ui-kit/components/loaders/SkeletonBoilerplate'
    );

export default {
    install(Vue, options) {
        Vue.mixin(userMixin);
        // UI
        Vue.component('AppImageUserAvatar', AppImageUserAvatar);
        // Forms
        Vue.component('AppInput', AppInput);
        Vue.component('AppInputPhone', AppInputPhone);
        Vue.component('AppInputSearch', AppInputSearch);
        Vue.component('AppInputPassword', AppInputPassword);
        Vue.component('AppSelect', AppSelect);
        Vue.component('AppSwitch', AppSwitch);
        Vue.component('AppTextarea', AppTextarea);
        Vue.component('AppCheckbox', AppCheckbox);
        Vue.component('AppSelectGender', AppSelectGender);
        Vue.component('AppAutoComplete', AppAutoComplete);
        Vue.component('AppRadioGenders', AppRadioGenders);
        Vue.component('AppSelectBirthday', AppSelectBirthday);
        Vue.component('AppRating', AppRating);
        Vue.component('AppDatePicker', AppDatePicker);
        // Modals
        Vue.component('AppModalNotEqual', AppModalNotEqual);
        Vue.component('AppModalLayoutDefault', AppModalLayoutDefault);
        // Buttons
        Vue.component('AppBtnClose', AppBtnClose);
        Vue.component('AppBtnCopy', AppBtnCopy);
        // Helpers
        Vue.component('AppSvg', AppSvg);
        Vue.component('AppBlockEmpty', AppBlockEmpty);
        Vue.component('AppBlockLoader', AppBlockLoader);
        Vue.component('AppSkeletonBoilerplate', AppSkeletonBoilerplate);
        Vue.component('AppBlockLayoutBoxSkeleton', AppBlockLayoutBoxSkeleton);
    },
};
